import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdateEditorsPick = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncUpdateEditorsPick, isPending } = useMutation('updateEditorsPick', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['editors-pick'] });
      toast.success(res.message);
      await revalidate(['editorRecommendedStores']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncUpdateEditorsPick, isPending };
};

export default useUpdateEditorsPick;
